(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  // Scope the logic to this section instance only
  const sectionEl = document.getElementById('shopify-section-{{ section.id }}');
  if (!sectionEl) return;

  function getVariantId() {
    const el = sectionEl.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!el) return null;
    return el.tagName === 'SELECT' ? el.value : el.getAttribute('value');
  }

  function filterGalleryByVariant(variantId) {
    if (!variantId) return;

    const mediaItems = sectionEl.querySelectorAll('.product__media-item');
    const thumbs = sectionEl.querySelectorAll('.product__thumb');

    let anyMatch = false;
    const genericMedia = [];

    const handleNode = (node) => {
      const ids = (node.dataset.variantIds || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      const isMatch = ids.includes(String(variantId));
      node.style.display = isMatch ? '' : 'none';
      if (isMatch) anyMatch = true;
      if (ids.length === 0) genericMedia.push(node); // remember “generic” images
    };

    mediaItems.forEach(handleNode);
    thumbs.forEach(handleNode);

    // Fallback: if no media tied to this variant, reveal generics
    if (!anyMatch) {
      genericMedia.forEach(n => n.style.display = '');
    }

    // Make the first visible thumb active (uses theme’s existing click behavior)
    const firstVisibleThumb = Array.from(thumbs).find(t => t.style.display !== 'none');
    if (firstVisibleThumb) firstVisibleThumb.click();

    // If gallery uses a slider, refresh it here:
    // if (window.productGallerySwiper) window.productGallerySwiper.update();
    // if (window.productFlickity) { window.productFlickity.reloadCells(); window.productFlickity.resize(); }
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    const id = getVariantId();
    if (id) filterGalleryByVariant(id);
  });

  // Theme variant change event (adjust name if your theme uses a different one)
  document.addEventListener('variant:change', (evt) => {
    if (!sectionEl.contains(evt.target)) return; // ignore other products
    const variant = evt.detail && evt.detail.variant;
    const id = variant && variant.id ? variant.id : getVariantId();
    filterGalleryByVariant(id);
  });

  // Fallback if no custom event
  sectionEl.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'id') {
      filterGalleryByVariant(e.target.value);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
